/**
 * PDP: hover zoom (CSS) + click lightbox via PhotoSwipe.
 * Tras swap AJAX de galería, llamar window.lopReinitPdpImageLightbox(source).
 */
(function () {
  var delegated = false;
  var touchMoved = false;
  var touchStartX = 0;
  var touchStartY = 0;
  var TOUCH_MOVE_THRESHOLD = 10;

  function getGalleryRoot(el) {
    return el && el.closest('.product-gallery-container');
  }

  function buildItems(galleryRoot) {
    if (!galleryRoot) return [];

    var triggers = galleryRoot.querySelectorAll('[data-lop-lightbox]');
    var itemsMap = {};

    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];
      var index = parseInt(trigger.getAttribute('data-lop-lightbox-index'), 10);
      if (isNaN(index)) continue;

      var src = trigger.getAttribute('data-lop-lightbox-src');
      if (!src || itemsMap[index]) continue;

      itemsMap[index] = {
        src: src,
        w: parseInt(trigger.getAttribute('data-lop-lightbox-w'), 10) || 0,
        h: parseInt(trigger.getAttribute('data-lop-lightbox-h'), 10) || 0,
        msrc: src
      };
    }

    return Object.keys(itemsMap)
      .map(Number)
      .sort(function (a, b) { return a - b; })
      .map(function (key) { return itemsMap[key]; });
  }

  function getActiveMobileIndex(trigger) {
    var container = trigger.closest('.product-carousel-container');
    if (container && container.swiper && typeof container.swiper.activeIndex === 'number') {
      return container.swiper.activeIndex;
    }
    return 0;
  }

  function openLightbox(galleryRoot, index) {
    if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
      return;
    }

    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    var items = buildItems(galleryRoot);
    if (!items.length) return;

    var safeIndex = Math.max(0, Math.min(index, items.length - 1));

    var pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
      index: safeIndex,
      maxSpreadZoom: 3,
      loop: false,
      allowPanToNext: false,
      showAnimationDuration: 200,
      hideAnimationDuration: 200,
      bgOpacity: 1,
      spacing: 0.1,
      history: false,
      focus: false,
      showHideOpacity: true,
      pinchToClose: true,
      closeOnScroll: false,
      closeOnVerticalDrag: true,
      mouseUsed: false,
      escKey: true,
      arrowKeys: true,
      shareButtons: [],
      getDoubleTapZoom: function (isMouseClick, item) {
        if (isMouseClick) {
          return item.initialZoomLevel < 0.7 ? 1 : 2.5;
        }
        return 2.5;
      }
    });

    pswp.listen('firstUpdate', function () {
      pswp.listen('parseVerticalMargin', function (item) {
        item.vGap = { top: 50, bottom: 50 };
      });
    });

    pswp.init();
  }

  function handleClick(e) {
    var expandBtn = e.target.closest('[data-lop-mobile-expand]');
    if (expandBtn) {
      var galleryRoot = getGalleryRoot(expandBtn);
      if (!galleryRoot) return;

      var index = parseInt(expandBtn.getAttribute('data-lop-lightbox-index'), 10);
      if (isNaN(index)) {
        index = getActiveMobileIndex(expandBtn);
      }

      e.preventDefault();
      e.stopPropagation();
      openLightbox(galleryRoot, index);
      return;
    }

    var trigger = e.target.closest('[data-lop-lightbox]');
    if (!trigger) return;

    if (touchMoved) {
      touchMoved = false;
      return;
    }

    var galleryRoot = getGalleryRoot(trigger);
    if (!galleryRoot) return;

    var index = parseInt(trigger.getAttribute('data-lop-lightbox-index'), 10);
    if (isNaN(index)) return;

    e.preventDefault();
    openLightbox(galleryRoot, index);
  }

  function handleTouchStart(e) {
    touchMoved = false;
    if (e.touches && e.touches.length) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }
  }

  function handleTouchMove(e) {
    if (!e.touches || !e.touches.length) return;
    var dx = Math.abs(e.touches[0].clientX - touchStartX);
    var dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > TOUCH_MOVE_THRESHOLD || dy > TOUCH_MOVE_THRESHOLD) {
      touchMoved = true;
    }
  }

  function bindDelegatedEvents() {
    if (delegated) return;
    delegated = true;

    document.addEventListener('click', handleClick);
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
  }

  function initPdpImageLightbox() {
    bindDelegatedEvents();
  }

  function reinitPdpImageLightbox() {
    bindDelegatedEvents();
  }

  window.lopReinitPdpImageLightbox = reinitPdpImageLightbox;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpImageLightbox);
  } else {
    initPdpImageLightbox();
  }
})();
